import React from "react";
import ReactDOM from "react-dom";

import { ICssOverride, BaseCollection } from "../../interfaces";
import { guid } from "../../utils";

const CssOverride = function <T extends BaseCollection>(
  WrappedComp: any,
  props: T,
  customProps?: any | null // use if passing named props: <some-component header={head}, navigation={nav}>
) {
  class CssOverride extends React.Component<T> {
    wrappedRef: any;
    cssOverride: ICssOverride;
    scope: string = "";

    constructor(props) {
      super(props);
    }

    getScopedStyles(scope: string) {
      if (props.css_override == null || props.css_override.custom_styles == null) return "";
      const {
        css_override: { custom_styles }
      } = props;
      const splitStyles = custom_styles.split("}");
      splitStyles.pop();

      const splitStylesWithScope = splitStyles.map((item) => {
        return `.${scope} ${item}}`;
      });

      return splitStylesWithScope.join(" ");
    }

    addScopedStyles(scope: string) {
      if (this.getScopedStyles(scope).length === 0) return null;

      const styles = this.getScopedStyles(scope)
        .replace(/(<br>+)|\n|\s{4}/gm, "")
        .trim();

      const element = window.document.createElement("style");
      element.setAttribute("type", "text/css");
      element.innerHTML = styles;
      element.innerText = styles;

      document.head.appendChild(element);
    }

    get cssClasses(): string[] | null {
      if (props.css_override == null || props.css_override.add_classes == null) return null;
      const {
        css_override: { add_classes }
      } = props;

      return add_classes.split(" ");
    }

    passProps() {
      return customProps != null ? customProps : props;
    }

    async componentDidMount() {
      if (this.wrappedRef != null) {
        this.scope = `scope-${guid()}`;
        this.addScopedStyles(this.scope);

        const classNames =
          this.cssClasses == null ? [this.scope] : [...this.cssClasses, this.scope];

        const classList = (ReactDOM.findDOMNode(this.wrappedRef) as HTMLElement).classList;

        (classNames || []).forEach((item) => {
          if (item.length > 0) {
            classList.add(item);
          }
        });
      }
    }

    render() {
      return (
        <>
          <WrappedComp
            {...this.passProps()}
            ref={() => {
              this.wrappedRef = this;
            }}
          />
        </>
      );
    }
  }

  return CssOverride;
};

export default CssOverride;
